export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS'
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REQUEST_RESET_PASSWORD = 'AUTH_REQUEST_RESET_PASSWORD'
export const AUTH_REQUEST_RESET_PASSWORD_SUCCESS =
  'AUTH_REQUEST_RESET_PASSWORD_SUCCESS'
export const AUTH_REQUEST_RESET_PASSWORD_ERROR =
  'AUTH_REQUEST_RESET_PASSWORD_ERROR'
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD'
export const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS'
export const AUTH_RESET_PASSWORD_ERROR = 'AUTH_RESET_PASSWORD_ERROR'
export const AUTH_INIT_FORGOT_PASSWORD_FORM = 'AUTH_INIT_FORGOT_PASSWORD_FORM'
export const AUTH_CHECK_CODE_AND_HASH = 'AUTH_CHECK_CODE_AND_HASH'
export const AUTH_CHECK_CODE_AND_HASH_SUCCESS =
  'AUTH_CHECK_CODE_AND_HASH_SUCCESS'
export const AUTH_CHECK_CODE_AND_HASH_ERROR = 'AUTH_CHECK_CODE_AND_HASH_ERROR'



// WEBPACK FOOTER //
// ./src/Reducers/Auth/const.js